import * as NamaURLS from "../constants/NamaURLS";
import * as urls from "../constants/NamaURLS";
import {findActionsWithActionId} from "../common/Metadata";
import {createGenericValueBasedOnTheValue, createGenericValueForType, getValue} from "../actions/GenericValues";
import {FromGridAction, processGUIActionResult} from "../actions/BaseDispatcher";
import * as CommonConstants from "../constants/CommonConstants";
import {isBarcodeOn} from "../login/ClientCache";
import {ajaxJSON, ajaxJSONWithTask} from "../common/NamaCommon";
import {currentUserId} from "../login/LoginPresenter";
import * as notifier from "../common/ErrorsNotification";
import {translateId} from "../common/Translator";

export class ActionPerformer {
    constructor() {
    }

    calcFieldTypeFromActionInfo(fieldId, questionsMetadata) {
        for (let fieldInfo of questionsMetadata) {
            if (fieldInfo.fieldId === fieldId)
                return fieldInfo.fieldType;
        }
    }

    createGUIActionParams(actionInfo, actionId, helper, questionFields) {
        let contextFields = new Map();
        if (questionFields && questionFields.length) {
            for (let dtoFilledQuestionField of questionFields) {
                let fieldValue = dtoFilledQuestionField.objValue;
                let genericValue = createGenericValueBasedOnTheValue(dtoFilledQuestionField.id, fieldValue);
                contextFields.set(dtoFilledQuestionField.id, genericValue);
            }
        }
        let contextRow = -1;
        helper.addContextFieldsToAction("", actionInfo.contextFields, -1, contextFields, FromGridAction.No, [], {}, helper);
        if (contextFields.has(CommonConstants.CONTEXTFIELD_SELECTEDLINE_INDEX))
            contextRow = getValue(contextFields.get(CommonConstants.CONTEXTFIELD_SELECTEDLINE_INDEX));
        let parameters = {
            "actionId": actionId,
            "userId": currentUserId,
            "entityType": helper.entityType,
            "barCodeOn": isBarcodeOn(),
            "contextFields": contextFields,
            "objectIndex": contextRow,
            "editViewName": helper.editViewName,
            "listViewName": helper.listViewName
        };
        return {
            "actionId": actionId,
            "questionFields": questionFields,
            "helper": helper,
            "contextRow": contextRow,
            "parameters": parameters,
        };
    }

    calcDefaultsOf(actionId, questionFields, callback, presenter, metaData, action) {
        let that = this;
        let actionInfo = findActionsWithActionId(actionId, metaData);
        if (!actionInfo || !actionInfo.actionInitializerClassName) {
            callback();
            return;
        }
        let parameters = that.createGUIActionParams(actionInfo, actionId, presenter, questionFields).parameters;
        ajaxJSON(urls.CalcGuiActionDefaults, {
                "params": JSON.stringify(parameters),
                "actionInitializerClassName": actionInfo.actionInitializerClassName
            }, (questionFields) => {
                callback(questionFields);
            }
        );
    }

    performAction(actionId, questionFields, metaData, presenter) {
        let that = this;
        let actionInfo = findActionsWithActionId(actionId, metaData);
        let contextFields = {};
        if (questionFields) {
            /*
            /**
             * @type {namaTypes.DTOFilledQuestionField}
             */
            for (let dtoFilledQuestionField of questionFields) {
                let fieldValue = dtoFilledQuestionField.objValue;
                let fieldType = that.calcFieldTypeFromActionInfo(dtoFilledQuestionField.id, actionInfo.questionsMetadata);
                let genericValue = createGenericValueForType(dtoFilledQuestionField.id, fieldValue, fieldType);
                contextFields[dtoFilledQuestionField.id] = genericValue;
            }
        }
        let row = -1;
        presenter.addContextFieldsToAction("", actionInfo.contextFields, row, contextFields, FromGridAction.No, [], {}, presenter);
        if (contextFields[CommonConstants.CONTEXTFIELD_SELECTEDLINE_INDEX])
            row = getValue(contextFields[CommonConstants.CONTEXTFIELD_SELECTEDLINE_INDEX]);
        let contextRow = row;
        /*
        /**
        * @type {namaTypes.GUIActionParameters}
        */
        let reqData = {};
        reqData.actionId = actionId;
        reqData.userId = currentUserId();
        reqData.entityType = presenter.entityType;
        reqData.barCodeOn = isBarcodeOn();
        reqData.contextFields = contextFields;
        reqData.objectIndex = contextRow;
        ajaxJSONWithTask(NamaURLS.PERFORM_Gui_Action, {request: JSON.stringify(reqData)}, (result) => {
            processGUIActionResult(result, presenter, -1, metaData);
        });
    }

    isRecordNotSaved() {

    }

    runCustomAction(actionPlaceHolder, presenter, metaData) {
        /**
         * @type {namaTypes.PerformActionReq}
         */
        let reqData = {};
        reqData.actionInfo = actionPlaceHolder.getCustomization();
        reqData.targetRecords = [];
        let ids = presenter.view.getSelectedRowsId();
        let types = presenter.view.getSelectedRowsEntityTypes();
        for (let i = 0; i < ids.length; i++) {
            reqData.targetRecords.push({
                entityType: types[i],
                id: ids[i]
            });
        }
        if (!ids || !ids.length) {
            notifier.showError(translateId("pleaseSelectRows"));
            return;
        }
        ajaxJSON(NamaURLS.PERFORM_Custom_action, {request: JSON.stringify(reqData)}, (result) => {
            presenter.view = null;
            presenter.start();
        });

    }

    /**
     *
     * @return {SearchAndSuggestionsProvider}
     */
    getSearchContextProvider() {

    }
}